import { trigger, state, style, animate, transition, keyframes } from '@angular/animations'

export const fadeInOut = trigger('fadeInOut', [
  state('in', style({ transform: 'translateX(0)' })),
  transition(':enter', [animate('450ms ease-out', keyframes([style({ opacity: 0 }), style({ opacity: 1 })]))]),
  transition(':leave', [animate('450ms ease-out', keyframes([style({ opacity: 1 }), style({ opacity: 0 })]))]),
])
